<script>
import { HorizontalBar  } from 'vue-chartjs'

export default {
  extends: HorizontalBar ,
  mounted () {
    this.renderChart({
      labels: [
        '1° ano',
        '2° ano',
        '3° ano',
        '4° ano',
        '5° ano',
        '6° ano',
        '7° ano',
        '8° ano',
        '9° ano',
      ],
      datasets: [
        {
          label: 'Professores/Educadores',
          backgroundColor: ['#9575CD', '#D4E157', '#78909C', '#FF3D00', '#8D6E63', '#FFD600', '#ff6384', '#69F0AE', '#01579B',],
          data: [15, 62, 37, 26, 53, 90, 22, 77, 44],
        },
      ],
    }, {
      animation: {
        duration: 1,
        onComplete() {
          var chartInstance = this.chart,
          ctx = chartInstance.ctx;

          ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
          ctx.textAlign = 'center';
          ctx.textBaseline = 'bottom';

          this.data.datasets.forEach(function(dataset, i) {
            var meta = chartInstance.controller.getDatasetMeta(i);
            meta.data.forEach(function(bar, index) {
              var data = dataset.data[index];
              ctx.fillText(data, bar._model.x + 10, bar._model.y + 6);
            });
          });
        }
      },
      scales: {
        yAxes:[{
         barPercentage: 0.3,
        }],
        xAxes:[{
          display: false,
          ticks: {
            beginAtZero: true,
            steps: 10,
            stepValue: 5,
            max: 100
          }
        }]
      },
      legend: {
        display: false
      },
      options: {
        responsive: true,
      },
    })
  }
}
</script>

<style>

</style>
